/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import BannerCategory from '../components/BannerCategory';
import BannerImage from '../components/BannerImage';
import BannerLinkButton from '../components/BannerLinkButton';
import BannerOverline from '../components/BannerOverline';
import BannerTeaser from '../components/BannerTeaser';
import BannerTitle from '../components/BannerTitle';
import Disruptor from '../components/Disruptor';
import LinkWrapper from '../components/LinkWrapper';
import AbstractLayout from './AbstractLayout';

export default class ThaliaReadingRound extends AbstractLayout {
	get key() {
		return 'thalia_reading_round';
	}

	content() {
		const { banner } = this.attrs;
		const backgroundColor = banner.visual()?.bg_color?.default;

		return (
			<LinkWrapper banner={banner}>
				<div className="Banner-content">
					<div className="BannerContentContainer">
						<BannerCategory banner={banner} />
						<BannerTitle banner={banner} />
						<BannerOverline banner={banner} />
						<BannerTeaser banner={banner} />
						<BannerLinkButton banner={banner} />
					</div>
					<div className="BannerImageWrapper" style={{ '--banner-bg': backgroundColor }}>
						<BannerImage banner={banner} />
						<Disruptor banner={banner} />
					</div>
				</div>
			</LinkWrapper>
		);
	}
}
